export const BILLING_PLAN_CODES = Object.freeze({
  FREE: 'FREE',
  PRO: 'PRO',
  PLATINUM: 'PLATINUM',
});

export const HOME_AUDIO_VISIBLE_LIMIT_ENTITLEMENT_KEY = 'home.audio.visible.limit';

export function normalizeBillingCode(value) {
  return typeof value === 'string' ? value.trim().toUpperCase() : '';
}

export function getBillingSubscriptionPlanCode(subscription) {
  return normalizeBillingCode(
    subscription?.effectivePlanCode
    || subscription?.planCode
    || subscription?.currentPlanCode
  );
}

export function billingCatalogPlans(catalogResponse) {
  if (Array.isArray(catalogResponse)) {
    return catalogResponse;
  }
  return Array.isArray(catalogResponse?.plans) ? catalogResponse.plans : [];
}

function safeNonNegativeInteger(value) {
  if (typeof value === 'number') {
    return Number.isSafeInteger(value) && value >= 0 ? value : null;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (/^\d+$/.test(trimmed)) {
      const parsed = Number(trimmed);
      return Number.isSafeInteger(parsed) ? parsed : null;
    }
  }
  return null;
}

export function findBillingEntitlement(entitlements, key) {
  if (!key) {
    return null;
  }
  if (Array.isArray(entitlements)) {
    return entitlements.find((entitlement) => entitlement?.key === key) || null;
  }
  if (entitlements && typeof entitlements === 'object') {
    const entitlement = entitlements[key];
    return entitlement && typeof entitlement === 'object'
      ? { key, ...entitlement }
      : null;
  }
  return null;
}

export function getBillingEntitlementIntegerValue(entitlement) {
  if (!entitlement || entitlement.unlimited === true) {
    return null;
  }
  return safeNonNegativeInteger(entitlement.integerValue)
    ?? safeNonNegativeInteger(entitlement.configuredValue)
    ?? safeNonNegativeInteger(entitlement.value);
}

export function resolveHomeAudioVisibleLimit(subscription) {
  const entitlement = findBillingEntitlement(
    subscription?.entitlements,
    HOME_AUDIO_VISIBLE_LIMIT_ENTITLEMENT_KEY
  );
  const entitlementLimit = getBillingEntitlementIntegerValue(entitlement);
  if (entitlementLimit !== null) {
    return entitlementLimit;
  }
  if (entitlement?.unlimited === true) {
    return null;
  }
  return null;
}

export function isHomeAudioVisibleLimitKnown(subscription) {
  const entitlement = findBillingEntitlement(
    subscription?.entitlements,
    HOME_AUDIO_VISIBLE_LIMIT_ENTITLEMENT_KEY
  );
  return entitlement?.unlimited === true || getBillingEntitlementIntegerValue(entitlement) !== null;
}

export function isFreeBillingSubscription(subscription) {
  return getBillingSubscriptionPlanCode(subscription) === BILLING_PLAN_CODES.FREE;
}
